<template>
	<div v-if="this.view_type === 'card'" :data-test-id="$props.field_meta.dbcolname" class="lm-dropdown-wrap">
		<div :class="['lm-dropdown', { disabled: is_disabled, open: dropdownOpen }]">
			<div
				class="lm-dropdown-selected form-control"
				ref="search"
				tabindex="0"
				:contenteditable="dropdownOpen"
				:placeholder="placeholder"
				@click="_handleOpenDropdown"
				@focus="_handleOpenDropdown"
				@keyup.esc="_handleBlurSearch"
				@keyup.space="_handleOpenDropdown"
				@blur="_handleBlurSearch"
				@input="_handleInputSearch"
				v-html="mutableLabel"
			></div>

			<i ref="icon" class="lm-dropdown-icon" @click="_handleOpenDropdown"></i>

			<div class="lm-dropdown-menu" ref="dropdown">
				<ul :style="{ 'max-height': maxHeight }">
					<li v-for="(option, index) in filteredOptions" :key="index">
						<a
							@mousedown.prevent="select(option)"
							:class="[{ select: isOptionSelected(option) }, 'lm-dropdown-menu--item']"
						>
							<span
								v-html="getLabel(option)"
								:style="{ color: isPublishType && option.color ? option.color : 'inherit' }"
							></span>
						</a>
					</li>

					<li v-if="!filteredOptions.length" class="no-options">
						<a href="javascript:void(0)" class="lm-dropdown-menu--item">
							<span>К сожалению, ничего не найдено.</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div class="help-block"></div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from './_mixins.js';
import axios from 'axios';
import urlUtil from '@uarmRoot/src/util-url';
import { ctrlParamsForAll, selectFieldsFromDatabase } from './_common-stuff.ts';

export default {
	name: 'ctrl_dropdown_page',
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Выпадающий список с запросом на page',
		params: {
			pageId: {
				name: 'ID page',
				editType: 'input',
			},
			selectFieldsFromDatabase,
			...ctrlParamsForAll,
		},
	},
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		/**
		 * Текущие выбранное значение
		 * @type {String||null}
		 */
		value: {
			default() {
				// параметр контрола defaultValue имеет более высокий приоритет
				// и применяется на более высоком уровне, тут речь только о ситуации когда ни значения ни defaultValue нет
				return this.view_type === 'filter' ? '' : null;
			},
		},
		card_meta: {
			type: Array,
		},
		/**
		 * Ключ для навзения поля в option.
		 * @type {string}
		 */
		label: {
			type: String,
			default: 'name',
		},
		/**
		 * Начальное значение
		 * @type {string}
		 */
		initial: {
			type: String,
			default: '',
		},
		/**
		 * Псевдо-placeholder
		 * Used in filter
		 * @type {string}
		 */
		placeholder: {
			type: String,
			default: '-- Выберите значение --',
		},
		/**
		 * Возвращяем только значение option, а не сам обьект.
		 * Значение ключа, которое будем возвращять.
		 * @type {string}
		 */
		return: {
			type: String,
			default: 'id',
		},
		/**
		 * Максимальная высота в выпадающем списке.
		 * @deprecated
		 * @type {string}
		 */
		maxHeight: {
			type: String,
			default: '200px',
		},
	},
	data: () => ({
		height: false,
		mutableLabel: '',
		mutableOptions: [],
		dropdownOpen: false,
	}),
	watch: {
		value(val) {
			this.mutableValue = val;

			if (this.return) {
				const initialValueWithReturn = this.return && this.mutableOptions.find((o) => o[this.return] === val);
				this.mutableValue = initialValueWithReturn || val;
			}

			this.setLabel(this.mutableValue);
		},
		/**
		 * Обновление списков
		 * @param  {any} val
		 * @returns {void}
		 */
		options(val) {
			this.mutableOptions = val;

			if (this.return) {
				const initialValueWithReturn = this.return && val.find((o) => o[this.return] === this.value);

				this.mutableValue = initialValueWithReturn || this.getLabel(this.value) || this.model;
				this.mutableLabel = this.getLabel(this.mutableValue);
			}
		},
	},
	computed: {
		isFilter() {
			return this.view_type === 'filter';
		},
		isRequired() {
			return !!this.field_meta.required;
		},
		isPublishType() {
			return this.field_meta.ctrlParams.isPublishType;
		},
		/**
		 * Выбранное значение в v-model
		 * @returns {object | string}
		 */
		model: {
			get() {
				return this.mutableValue;
			},
			set(v) {
				if (this.return) {
					this.c_value = v[this.return];
					this.mixin_inputEvent({
						ctrlCode: this.$props.field_meta.ctrlCode,
						dbcolname: this.$props.field_meta.dbcolname,
						evtType: 'set',
						fullValue: {
							id: v.id,
							name: v.name,
							REVERT_VALUE_TO_PLAIN: true,
						},
					});
					this.mixin_saveEvent();
					return this.$emit('input', v[this.return]);
				}
			},
		},
		filteredOptions() {
			const search = (this.mutableLabel || '').toString().toLowerCase();

			return this.mutableOptions.filter((option) => {
				if (typeof option === 'object') {
					if (option.hasOwnProperty(this.label)) {
						return option[this.label].toString().toLowerCase().indexOf(search) > -1;
					} else {
						return console.warn(`[dropdown warn]: Label key "option.${this.label}"`);
					}
				}
				return option.toString().toLowerCase().indexOf(search) > -1;
			});
		},
	},
	async created() {
		if (this.view_type !== 'card') return;

		try {
			const { data } = await axios.get(
				`${urlUtil.getDomain()}/ru/page/${this.c_ctrlParams.pageId}?${this.getParamsForQuery()}`,
			);
			this.mutableOptions = data;

			// Default value через MetaWiz записывается строкой.
			const initialValueWithReturn = this.return && this.mutableOptions.find((o) => o[this.return] == this.value);

			this.mutableValue = initialValueWithReturn || this.initial;
			this.mutableLabel = this.getLabel(this.mutableValue);
		} catch (error) {
			console.error(error);
			this.$notify({ type: 'error', text: 'Ошибка получения данных' });
		}
	},
	methods: {
		/**
		 *
		 * @returns {*}
		 */
		getParamsForQuery() {
			return this.c_ctrlParams.selectFieldsFromDatabase.reduce((acc, dbColumnName) => {
				const value = this.$props.card_meta.find((meta) => meta.dbcolname === dbColumnName)?.value || 0;
				acc += `${dbColumnName}=${value}&`;
				return acc;
			}, '');
		},
		/**
		 * Изменяем видимость выпадающего списка
		 * Если кликнули в не области, закрываем.
		 * @param  {Event} e - Event
		 * @returns {void}
		 */
		toggleDropdown(e) {
			let isClickOutside = e.target != this.$refs.dropdown && e.target != this.$refs.search && e.target != this.$el;
			isClickOutside && this._handleCloseDropdown();
		},
		/**
		 * @param  {Event} e - Event
		 * @returns {void}
		 */
		_handleInputSearch(e) {
			this.mutableLabel = e.target.innerText.replace(/\xA0/, '').replace(/\s+/, ' ');
			this.$nextTick(() => {
				setCaret(this.$refs.search);
			});
		},
		/**
		 * @returns {void}
		 */
		_handleBlurSearch() {
			// TODO: need fixed. Bug click to lm-dropdown-icon. First event blur -> close -> after click icon open dropdown
			setTimeout(() => {
				this._handleCloseDropdown(); // Fix tabulate.
				this.mutableLabel = this.getLabel(this.mutableValue);
			}, 100);
		},
		/**
		 * Открываем выпадающий список.
		 * @param  {Event} e - Event
		 * @returns {void}
		 */
		_handleOpenDropdown(e) {
			if (this.dropdownOpen || this.is_disabled) return;

			this.mutableLabel = '';
			this.dropdownOpen = true;
			setCaret(this.$refs.search);

			this.$nextTick(() => {
				this.container = document.querySelectorAll('body')[0];
				if (this.container) {
					this.container.addEventListener('click', this.toggleDropdown);
				}
			});
		},
		/**
		 * Закрываем выпадающий список
		 * @param  {Event} e
		 * @returns {void}
		 */
		_handleCloseDropdown() {
			this.dropdownOpen = false;
			this.container.removeEventListener('click', this.toggleDropdown, false);
		},
		/**
		 * Устанавливаем выбранный option.
		 * @param  {object | string} option
		 * @returns {void}
		 */
		select(option) {
			if (this.is_disabled) return;

			this.model = option;
			this.$refs.search.blur();
			this._handleCloseDropdown();
		},
		/**
		 * Проверяем, выбранн ли option.
		 * @param  {object | string} option
		 * @returns Boolean
		 */
		isOptionSelected(option) {
			return this.mutableValue === option;
		},
		setLabel(val) {
			this.mutableLabel = this.getLabel(val);
		},
		getLabel(option) {
			if (typeof option === 'object' && this.label && !!option[this.label]) {
				return option[this.label];
			} else {
				const label = this.mutableOptions.find((i) => i[this.return] === option);
				if (label) {
					return label[this.label];
				} else return option;
			}
		},
	},
};

function setCaret(el) {
	let range = document.createRange(),
		sel = window.getSelection(),
		lastKnownIndex = -1;

	for (let i = 0; i < el.childNodes.length; i++) {
		if (isTextNodeAndContentNoEmpty(el.childNodes[i])) {
			lastKnownIndex = i;
		}
	}

	if (lastKnownIndex === -1) return false;

	let row = el.childNodes[lastKnownIndex],
		col = row.textContent.length;

	range.setStart(row, col);
	range.collapse(true);
	sel.removeAllRanges();
	sel.addRange(range);

	el.focus();
}

function isTextNodeAndContentNoEmpty(node) {
	return node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0;
}
</script>

<style lang="css">
.lm-dropdown-wrap {
	position: relative;
}

.lm-dropdown {
	padding: 0;
	width: 100%;
	height: 30px;
	/*width: 300px;*/
	max-width: 100%;
	min-width: 300px;
	user-select: none;
	position: relative;
	white-space: normal;
	display: inline-block;
	word-wrap: break-word;
}

.armlist-table .lm-dropdown {
	min-width: 150px;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-selected {
	width: 100%;
	height: 30px;
	display: block;
	color: #808792;
	font-size: 14px;
	overflow: hidden;
	text-align: left;
	line-height: 30px;
	border-radius: 2px;
	white-space: nowrap;
	background: #ffffff;
	padding: 0 30px 0 16px;
	text-overflow: ellipsis;
	border: 1px solid #cbd0d8;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-selected:empty:before {
	display: block;
	pointer-events: none;
	content: attr(placeholder);
}

.lm-dropdown-wrap .lm-dropdown .lm-close-icon,
.lm-dropdown-wrap .lm-dropdown .lm-dropdown-icon {
	top: 13px;
	right: 14px;
	width: 10px;
	height: 6px;
	display: block;
	cursor: pointer;
	position: absolute;
	/*background-size: 10px;*/
	/*background-position: 50%;*/
	background-repeat: no-repeat;
	transition: transform 300ms ease;
	/*background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="%23666" fill-rule="nonzero" d="M8 10.625L4.4 7.25l.933-.875L8 8.875l2.667-2.5.933.875z"/></svg>')*/
	background-image: url('data:image/svg+xml;utf8,<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.15179 0.143555H8.31473C8.25781 0.143555 8.20424 0.171457 8.17076 0.217215L5 4.58775L1.82924 0.217215C1.79576 0.171457 1.74219 0.143555 1.68527 0.143555H0.848216C0.775671 0.143555 0.733261 0.226144 0.775671 0.285296L4.71094 5.71052C4.8538 5.90695 5.14621 5.90695 5.28795 5.71052L9.22322 0.285296C9.26674 0.226144 9.22433 0.143555 9.15179 0.143555V0.143555Z" fill="%23A4B3C0"/> </svg>');
}

.lm-dropdown-wrap .lm-dropdown .lm-close-icon {
	transform: rotate(-180deg);
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu {
	z-index: 100;
	display: none;
	min-height: 100%;
	background-clip: padding-box;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu ul {
	padding: 0;
	margin: 0;
	overflow: auto;
	text-align: left;
	list-style: none;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu ul li {
	margin: 0;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu .lm-dropdown-menu--item {
	width: 100%;
	color: #282a36;
	display: block;
	font-size: 14px;
	overflow: hidden;
	padding: 4px 14px;
	white-space: nowrap;
	text-decoration: none;
	text-overflow: ellipsis;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu ul li.no-options .lm-dropdown-menu--item {
	color: #808792;
	pointer-events: none;
}

.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu .lm-dropdown-menu--item.select,
.lm-dropdown-wrap .lm-dropdown .lm-dropdown-menu .lm-dropdown-menu--item:hover {
	color: #0063da;
	background-color: rgba(76, 159, 159, 0.15);
}

.lm-dropdown-wrap .lm-dropdown.open .lm-dropdown-selected {
	border-bottom-left-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.lm-dropdown-wrap .lm-dropdown.open .lm-dropdown-icon {
	transform: rotate(-180deg);
}

.lm-dropdown-wrap .lm-dropdown.open .lm-dropdown-menu {
	left: 0;
	top: 30px;
	width: 100%;
	display: block;
	cursor: pointer;
	margin-top: -1px;
	position: absolute;
	background-color: #fff;
	border: 1px solid #cbd0d8;
	border-radius: 0 0 4px 4px;
	box-shadow: 0 4px 16px 0 rgba(40, 42, 54, 0.16);
}

.lm-dropdown-wrap .lm-dropdown.open .lm-dropdown-menu ul {
	padding: 2px 0;
}

.lm-dropdown-wrap .lm-dropdown.disabled {
	cursor: no-drop;
}

.lm-dropdown-wrap .lm-dropdown.disabled .lm-dropdown-selected {
	pointer-events: none;
	background-color: #f0eff4;
}
</style>
